import axios from "@/axios";

export default {
	namespaced: true,
	state: {
		// Calendar Labels
		eventLabels: [],

		// Simple Calendar State
		events: [],

		currentPage: 1,
		totalPages: 0,
		totalItems: 0,
		isLoadingEvents: false
	},
	mutations: {
		ADD_EVENT(state, event) {
			state.events = [...state.events, event];
		},
		SET_EVENTS(state, events) {
			state.events = events;
		},
		SET_IS_LOADING_EVENTS_STATE(state, value) {
			state.isLoadingEvents = value;
		},
		SET_TASK_COMPLETED(state, task_id) {
			for (const item of state.events) {
				if (!item.tasks.length) {
					continue;
				}

				const idx = item.tasks.findIndex(el => el.task_id === task_id);

				if (idx !== -1) {
					item.tasks[idx].is_completed = true;
				}
			}
		},
		SET_TASK_BY_ADMIN(state, task_id) {
			for (const item of state.events) {
				if (!item.tasks.length) {
					continue;
				}

				const idx = item.tasks.findIndex(el => el.task_id === task_id);

				if (idx !== -1) {
					item.tasks[idx].is_by_admin = true;
				}
			}
		},
		REOPEN_TASK(state, task_id) {
			for (const item of state.events) {
				if (!item.tasks.length) {
					continue;
				}

				const idx = item.tasks.findIndex(el => el.task_id === task_id);

				if (idx !== -1) {
					item.tasks[idx].is_completed = false;
				}
			}
		},
		SET_LABELS(state, labels) {
			state.eventLabels = labels;
		},
		UPDATE_EVENT(state, event) {
			const eventIndex = state.events.findIndex(e => e.id === event.id);
			Object.assign(state.events[eventIndex], event);
		},
		DELETE_TASK(state, eventId) {
			for (const item of state.events) {
				if (!item.tasks.length) {
					continue;
				}

				const idx = item.tasks.findIndex(el => el.task_id === eventId);

				if (idx !== -1) {
					item.tasks.splice(idx, 1);
				}
			}
			state.events = state.events.filter(el => el.tasks.length);
			// const taskIndex = state.events.findIndex((e) => e.id === eventId)
			// state.events.splice(taskIndex, 1)
		},
		SET_CURRENT_PAGE(state, page) {
			state.currentPage = page;
		},
		SET_TOTAL_PAGES(state, total) {
			state.totalPages = total;
		},
		SET_TOTAL_ITEMS_COUNT(state, count) {
			state.totalItems = count;
		}
	},
	actions: {
		async addEvent({ commit, dispatch, rootGetters }, event) {
			try {
				let res = await axios.post(
					`${rootGetters["getRole"]}/task/create`,
					event
				);
			} catch (e) {
				throw new Error(e);
			}

			await dispatch("updateNotifications");
		},

		async setTaskCompleted({ commit, dispatch, rootGetters }, task) {
			try {
				let res = await axios.post(
					`${rootGetters["getRole"]}/task/complete/${task.task_id}`,
					{ is_completed: true }
				);
				if (res.status === 200)
					commit("SET_TASK_COMPLETED", task.task_id);
			} catch (e) {
				console.error(e);
			}

			await dispatch("updateNotifications");
		},

		async reopenTask({ commit, dispatch, rootGetters }, task) {
			try {
				let res = await axios.post(
					`${rootGetters["getRole"]}/task/complete/${task.task_id}`,
					{ is_completed: false }
				);
				if (res.status === 200) commit("REOPEN_TASK", task.task_id);
			} catch (e) {
				console.error(e);
			}

			await dispatch("updateNotifications");
		},

		async deleteTask({ commit, dispatch, rootGetters }, task) {
			try {
				let res = await axios.post(
					`${rootGetters["getRole"]}/task/delete/${task.task_id}`
				);
				if (res.status === 200) commit("DELETE_TASK", task.task_id);
			} catch (e) {
				console.error(e);
			}

			await dispatch("updateNotifications");
		},

		async fetchEvents({ commit, dispatch, rootGetters }, payload) {
			let options = await dispatch("getOptions", payload);

			try {
				commit("SET_IS_LOADING_EVENTS_STATE", true);
				let res = await axios.get(
					`${rootGetters["getRole"]}/task?${options}`
				);

				const events = rootGetters["calendar/getEvents"];
				commit("SET_EVENTS", [...events, ...res.data.data]);
				commit("SET_TOTAL_ITEMS_COUNT", res.data.count);
			} catch (e) {
				console.error(e);
				throw new Error(e);
			} finally {
				commit("SET_IS_LOADING_EVENTS_STATE", false);
			}
		},

		async fetchCalendarEvents({ commit, dispatch, rootGetters }, { payload, showDeadlines =  true }) {
			let options = await dispatch("getOptions", payload);

			try {
				let deadlines = {items:[]};
				if(showDeadlines) {
					deadlines = await dispatch(
						"fetchCalendarEventsDeadlines",
						payload
					);
					console.log(deadlines, ' deadlines')
				}
				commit("SET_IS_LOADING_EVENTS_STATE", true);
				let res = await axios.get(
					`${rootGetters["getRole"]}/task?${options}`
				);

				const formattedDeadlines = deadlines.items.map(el => {
					return {
						date_time: el.date,
						description: el.label,
						is_completed: false
					};
				});

				return [...res.data.data, { tasks: formattedDeadlines }];
			} catch (e) {
				console.error(e);
				throw new Error(e);
			} finally {
				commit("SET_IS_LOADING_EVENTS_STATE", false);
			}
		},

		async fetchCalendarEventsDeadlines(
			{ commit, dispatch, rootGetters },
			payload
		) {
			let options = "";

			if (payload) {
				options += payload.dateFrom
					? `&dateFrom=${payload.dateFrom}`
					: "";
				options += payload.dateTo ? `&dateTo=${payload.dateTo}` : "";
			}

			try {
				commit("SET_IS_LOADING_EVENTS_STATE", true);
				let res = await axios.get(
					`${rootGetters["getRole"]}/deadlines?${options}`
				);

				return res.data.data;
			} catch (e) {
				console.error(e);
				throw new Error(e);
			} finally {
				commit("SET_IS_LOADING_EVENTS_STATE", false);
			}
		},

		getOptions({ _ }, payload) {
			let options = "";

			if (payload) {
				options += payload.dateFrom
					? `&filter[date_from]=${payload.dateFrom}`
					: "";
				options += payload.dateTo
					? `&filter[date_to]=${payload.dateTo}`
					: "";
				options += payload.actual ? `&filter[actual]=true` : "";
				options += payload.limit >= 0 ? `&limit=${payload.limit}` : "";
				options +=
					payload.offset >= 0 ? `&offset=${payload.offset}` : "";
			}

			return options;
		},

		resetEvents({ commit }) {
			commit("SET_EVENTS", []);
			commit("SET_TOTAL_ITEMS_COUNT", 0);
		},

		async assignTaskToManager({ commit }, { task, manager }) {
			try {
				let res = await axios.post(
					`admin/task/assign-to-manager/${task.task_id}`,
					{ manager_id: manager.id }
				);
				if (res.status === 200)
					commit("SET_TASK_BY_ADMIN", task.task_id);
			} catch (e) {
				console.error(e);
			}
		},

		eventDragged({ commit }, payload) {
			// return new Promise((resolve, reject) => {
			// 	axios.post(`/api/apps/calendar/event/dragged/${payload.event.id}`, {payload})
			// 		.then((response) => {
			//
			// 			// Convert Date String to Date Object
			// 			const event = response.data
			// 			event.startDate = new Date(event.startDate)
			// 			event.endDate = new Date(event.endDate)
			//
			// 			commit('UPDATE_EVENT', event)
			// 			resolve(response)
			// 		})
			// 		.catch((error) => {
			// 			reject(error)
			// 		})
			// })
		}
	},
	getters: {
		getEvent: state => eventId =>
			state.events.find(event => event.id === eventId),

		getEvents: state => {
			return state.events.map(event => {
				return {
					...event,
					title: event.description,
					startDate: event.date_time
				};
			});
		},

		getIsLoadingEvents: state => {
			return state.isLoadingEvents;
		},

		hasNextPage: state => {
			return state.events.length < state.totalItems;
		},

		getCurrentPage: state => {
			return state.currentPage;
		}
	}
};
